import React, { useState } from 'react'
import ReactImageLightbox from 'react-image-lightbox'
import 'react-image-lightbox/style.css'

import { getSrcFromImageInfo } from '../util'
import './lightbox-custom.css'

const Lightbox = ({ gatsbyImages, selectedImageIndex = 0, onCloseRequest = () => {} }) => {
  const [lightboxImageIndex, setLightboxImageIndex] = useState(selectedImageIndex)
  return (
    <ReactImageLightbox
      mainSrc={getSrcFromImageInfo(gatsbyImages[lightboxImageIndex])}
      nextSrc={getSrcFromImageInfo(gatsbyImages[(lightboxImageIndex + 1) % gatsbyImages.length])}
      prevSrc={getSrcFromImageInfo(
        gatsbyImages[(lightboxImageIndex + gatsbyImages.length - 1) % gatsbyImages.length]
      )}
      onCloseRequest={onCloseRequest}
      onMovePrevRequest={() =>
        setLightboxImageIndex((lightboxImageIndex + gatsbyImages.length - 1) % gatsbyImages.length)
      }
      onMoveNextRequest={() =>
        setLightboxImageIndex((lightboxImageIndex + 1) % gatsbyImages.length)
      }
    />
  )
}

export default Lightbox
